
import ReactDOM from 'react-dom/client';
import { MotoclickApp } from './MotoclickApp';
import './styles/styles.scss';
import './i18n/i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <MotoclickApp/>
);
